import React, { Component } from "react";
import { Gallery } from "components";

class Projects extends Component {
  render() {
    return (
      <div className="container-fluid" style={{ padding: "3em" }}>
        <div className="row">
          <div style={{ marginBottom: 10 }} className="col-xs-12">
            <h1 className="sans-serif m-t-sm">Gallery</h1>
          </div>
        </div>
        <Gallery />
      </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.jsx